import { useAnalytics } from '@medely/ui-kit';
import { useCurrentUser } from '../useCurrentUser';
import { useOTAMetadata } from '../useOTAMetadata';

export type Platform = 'web' | 'mobile';

export function useApplicationHelpIconEvent() {
  const analytics = useAnalytics();
  const { currentUser } = useCurrentUser();
  const professionalId = currentUser?.professional?.id;
  const applicationStatus = currentUser?.professional?.application_status;
  const otaMetadata = useOTAMetadata();

  const trackHelpIconOpened = ({ platform }: { platform: Platform }) => {
    analytics.track('Application - Help Icon - Opened', {
      context: 'Application',
      subcontext: 'Help Icon',
      action: 'Opened',
      platform,
      professional_id: professionalId,
      application_status: applicationStatus,
      ...otaMetadata,
    });
  };

  return { trackHelpIconOpened };
}
